import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FetchDataService {
  constructor(private http: HttpClient) {}

  API_URL = '/api/';

  fetchDetails() {
    return this.http.get(this.API_URL + 'test');
  }
}
